export class Task {
  public static async Delay(durationInMilliseconds: number): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, durationInMilliseconds));
  }
}
